export default {"src":"/_next/static/media/ic-select.fca17e11.svg","height":8,"width":5,"blurWidth":0,"blurHeight":0};